import { Box, Container, Grid, Typography } from "@mui/material";
import BlogCard from "./BlogCard";
import {Link} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";

export default function Blogs() {
    const blogListData = useSelector((state) => state.webSetting.blogListData);


    return (
        <Box py={6} sx={{ background: '#FFFFFF' }}>
            <Container>
                <Typography color="primary.main" fontWeight={600} textAlign="center">
                    Blog & News
                </Typography>
                <Typography textAlign="center" variant="h2" mb={2}>
                    Read Our Latest News
                </Typography>

                {/* Grid container for blog cards */}
                <Grid container spacing={4}>
                    {Object.values(blogListData)?.map((data, index) => (
                        <Grid item xs={12} sm={6} md={4} key={data.id}>
                            <BlogCard key={index} data={data}/>
                        </Grid>
                    ))}
                </Grid>
                <Link to="/blog" className='flex justify-center'>
                    <button className="button mt-5" disableElevation>
                        View All
                    </button>
                </Link>
            </Container>
        </Box>
    );
}
